// removed by extract-text-webpack-plugin
module.exports = {"image":"_3i-L-","float":"_3pEZJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/present/Floating.css
// module id = 837
// module chunks = 0